<template>
    <div
        class="flex h-screen flex-col items-center justify-center overflow-hidden"
    >
        <div class="relative flex justify-center md:max-w-lg">
            <svg
                width="470"
                height="368"
                viewBox="0 0 470 368"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g filter="url(#filter0_d_3223_6798)">
                    <path
                        d="M50 45H420V287C420 290.314 417.314 293 414 293H56C52.6863 293 50 290.314 50 287V45Z"
                        fill="#161E2E"
                    />
                    <path
                        d="M50 31C50 27.6863 52.6863 25 56 25H414C417.314 25 420 27.6863 420 31V45H50V31Z"
                        fill="#D2D6DC"
                    />
                    <circle cx="63" cy="35" r="3" fill="#F4F5F7" />
                    <circle cx="73" cy="35" r="3" fill="#F4F5F7" />
                    <circle cx="83" cy="35" r="3" fill="#F4F5F7" />
                </g>
                <defs>
                    <filter
                        id="filter0_d_3223_6798"
                        x="0"
                        y="0"
                        width="470"
                        height="368"
                        filterUnits="userSpaceOnUse"
                        color-interpolation-filters="sRGB"
                    >
                        <feFlood
                            flood-opacity="0"
                            result="BackgroundImageFix"
                        />
                        <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                        />
                        <feOffset dy="25" />
                        <feGaussianBlur stdDeviation="25" />
                        <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                        />
                        <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_3223_6798"
                        />
                        <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_3223_6798"
                            result="shape"
                        />
                    </filter>
                </defs>
            </svg>

            <div class="absolute -left-3 top-[93px]">
                <svg
                    width="492"
                    height="168"
                    viewBox="0 0 492 168"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <rect
                        opacity="0.2"
                        x="19"
                        y="26"
                        width="456"
                        height="116"
                        stroke="#917DFF"
                        stroke-width="4"
                    />
                    <rect
                        x="17.5"
                        y="24.5"
                        width="459"
                        height="119"
                        stroke="#917DFF"
                    />
                    <g filter="url(#filter0_d_3223_6742)">
                        <circle cx="476" cy="53" r="13" fill="#3C4048" />
                    </g>
                    <path
                        d="M477.672 53.5L480.016 51.1562C480.32 50.875 480.32 50.4062 480.016 50.125L479.5 49.6094C479.219 49.3047 478.75 49.3047 478.469 49.6094L476.125 51.9531L473.758 49.6094C473.477 49.3047 473.008 49.3047 472.727 49.6094L472.211 50.125C471.906 50.4062 471.906 50.875 472.211 51.1562L474.555 53.5L472.211 55.8672C471.906 56.1484 471.906 56.6172 472.211 56.8984L472.727 57.4141C473.008 57.7188 473.477 57.7188 473.758 57.4141L476.125 55.0703L478.469 57.4141C478.75 57.7188 479.219 57.7188 479.5 57.4141L480.016 56.8984C480.32 56.6172 480.32 56.1484 480.016 55.8672L477.672 53.5Z"
                        fill="white"
                    />
                    <g filter="url(#filter1_d_3223_6742)">
                        <circle cx="476" cy="84" r="13" fill="#3C4048" />
                    </g>
                    <path
                        d="M480.875 77.5H474.125C473.492 77.5 473 78.0156 473 78.625V85.375C473 86.0078 473.492 86.5 474.125 86.5H480.875C481.484 86.5 482 86.0078 482 85.375V78.625C482 78.0156 481.484 77.5 480.875 77.5ZM474.125 87.25C473.07 87.25 472.25 86.4297 472.25 85.375V80.5H471.125C470.492 80.5 470 81.0156 470 81.625V88.375C470 89.0078 470.492 89.5 471.125 89.5H477.875C478.484 89.5 479 89.0078 479 88.375V87.25H474.125Z"
                        fill="white"
                    />
                    <g filter="url(#filter2_d_3223_6742)">
                        <circle cx="476" cy="115" r="13" fill="#3C4048" />
                    </g>
                    <path
                        d="M481.148 111.547L479.203 109.602C479.016 109.414 478.664 109.25 478.406 109.25H472.125C471.492 109.25 471 109.766 471 110.375V118.625C471 119.258 471.492 119.75 472.125 119.75H480.375C480.984 119.75 481.5 119.258 481.5 118.625V112.344C481.5 112.086 481.336 111.734 481.148 111.547ZM476.25 118.25C475.406 118.25 474.75 117.594 474.75 116.75C474.75 115.93 475.406 115.25 476.25 115.25C477.07 115.25 477.75 115.93 477.75 116.75C477.75 117.594 477.07 118.25 476.25 118.25ZM478.5 111.125V113.469C478.5 113.633 478.359 113.75 478.219 113.75H472.781C472.617 113.75 472.5 113.633 472.5 113.469V111.031C472.5 110.891 472.617 110.75 472.781 110.75H478.125C478.195 110.75 478.266 110.797 478.336 110.844L478.406 110.914C478.453 110.961 478.5 111.055 478.5 111.125Z"
                        fill="white"
                    />
                    <path
                        d="M428 12C428 10.8954 428.895 10 430 10H475C476.105 10 477 10.8954 477 12V24H428V12Z"
                        fill="#917DFF"
                    />
                    <path
                        d="M436.474 16.3885C436.315 15.5575 435.65 15.027 434.499 15.027C433.317 15.027 432.511 15.6087 432.515 16.5163C432.511 17.2322 432.952 17.7053 433.895 17.9002L434.733 18.076C435.183 18.1751 435.394 18.3572 435.394 18.6353C435.394 18.9709 435.03 19.2234 434.48 19.2234C433.95 19.2234 433.604 18.9933 433.505 18.5522L432.377 18.6609C432.521 19.5621 433.278 20.0959 434.483 20.0959C435.711 20.0959 436.577 19.4599 436.58 18.5298C436.577 17.8299 436.126 17.4016 435.199 17.2003L434.362 17.0213C433.863 16.9094 433.665 16.7369 433.668 16.4524C433.665 16.12 434.033 15.8899 434.515 15.8899C435.049 15.8899 435.33 16.1808 435.42 16.5036L436.474 16.3885ZM439.985 15.0909H439.017V13.9148H437.86V15.0909H437.163V15.9858H437.86V18.7152C437.854 19.6388 438.525 20.0927 439.394 20.0671C439.723 20.0575 439.95 19.9936 440.075 19.9521L439.88 19.0476C439.816 19.0636 439.685 19.0923 439.541 19.0923C439.25 19.0923 439.017 18.9901 439.017 18.5234V15.9858H439.985V15.0909ZM440.953 20H442.11V17.114C442.11 16.4908 442.58 16.0497 443.216 16.0497C443.411 16.0497 443.653 16.0849 443.753 16.1168V15.0526C443.647 15.0334 443.465 15.0206 443.337 15.0206C442.775 15.0206 442.305 15.3402 442.126 15.9091H442.075V15.0909H440.953V20ZM447.65 17.9354C447.65 18.6832 447.116 19.054 446.605 19.054C446.049 19.054 445.678 18.6609 445.678 18.0376V15.0909H444.521V18.2166C444.521 19.396 445.192 20.0639 446.158 20.0639C446.893 20.0639 447.41 19.6772 447.634 19.1275H447.685V20H448.807V15.0909H447.65V17.9354ZM452.138 20.0959C453.372 20.0959 454.158 19.364 454.241 18.3221H453.135C453.036 18.8494 452.656 19.1531 452.148 19.1531C451.425 19.1531 450.959 18.549 450.959 17.5455C450.959 16.5547 451.435 15.9602 452.148 15.9602C452.704 15.9602 453.046 16.3182 453.135 16.7912H454.241C454.161 15.7269 453.33 15.027 452.132 15.027C450.694 15.027 449.786 16.0657 449.786 17.5646C449.786 19.0508 450.671 20.0959 452.138 20.0959ZM457.642 15.0909H456.674V13.9148H455.517V15.0909H454.82V15.9858H455.517V18.7152C455.511 19.6388 456.182 20.0927 457.051 20.0671C457.38 20.0575 457.607 19.9936 457.732 19.9521L457.537 19.0476C457.473 19.0636 457.342 19.0923 457.198 19.0923C456.907 19.0923 456.674 18.9901 456.674 18.5234V15.9858H457.642V15.0909ZM461.739 17.9354C461.739 18.6832 461.205 19.054 460.694 19.054C460.138 19.054 459.767 18.6609 459.767 18.0376V15.0909H458.61V18.2166C458.61 19.396 459.281 20.0639 460.246 20.0639C460.982 20.0639 461.499 19.6772 461.723 19.1275H461.774V20H462.896V15.0909H461.739V17.9354ZM464.086 20H465.243V17.114C465.243 16.4908 465.712 16.0497 466.348 16.0497C466.543 16.0497 466.786 16.0849 466.885 16.1168V15.0526C466.78 15.0334 466.598 15.0206 466.47 15.0206C465.907 15.0206 465.438 15.3402 465.259 15.9091H465.207V15.0909H464.086V20ZM469.625 20.0959C470.769 20.0959 471.556 19.5366 471.76 18.6832L470.68 18.5618C470.523 18.9773 470.14 19.1946 469.641 19.1946C468.893 19.1946 468.398 18.7024 468.388 17.8619H471.808V17.5071C471.808 15.7844 470.773 15.027 469.564 15.027C468.158 15.027 467.241 16.0593 467.241 17.5742C467.241 19.1147 468.145 20.0959 469.625 20.0959ZM468.392 17.082C468.427 16.4556 468.89 15.9283 469.58 15.9283C470.245 15.9283 470.693 16.4141 470.699 17.082H468.392Z"
                        fill="white"
                    />
                    <path
                        d="M55 144H79V166C79 167.105 78.1046 168 77 168H57C55.8954 168 55 167.105 55 166V144Z"
                        fill="#917DFF"
                    />
                    <path
                        d="M72.375 154.438H68.4375V150.5C68.4375 150.035 68.0273 149.625 67.5625 149.625H66.6875C66.1953 149.625 65.8125 150.035 65.8125 150.5V154.438H61.875C61.3828 154.438 61 154.848 61 155.312V156.188C61 156.68 61.3828 157.062 61.875 157.062H65.8125V161C65.8125 161.492 66.1953 161.875 66.6875 161.875H67.5625C68.0273 161.875 68.4375 161.492 68.4375 161V157.062H72.375C72.8398 157.062 73.25 156.68 73.25 156.188V155.312C73.25 154.848 72.8398 154.438 72.375 154.438Z"
                        fill="white"
                    />
                    <path
                        d="M55 2C55 0.89543 55.8954 0 57 0H77C78.1046 0 79 0.895431 79 2V24H55V2Z"
                        fill="#917DFF"
                    />
                    <path
                        d="M72.375 10.4375H68.4375V6.5C68.4375 6.03516 68.0273 5.625 67.5625 5.625H66.6875C66.1953 5.625 65.8125 6.03516 65.8125 6.5V10.4375H61.875C61.3828 10.4375 61 10.8477 61 11.3125V12.1875C61 12.6797 61.3828 13.0625 61.875 13.0625H65.8125V17C65.8125 17.4922 66.1953 17.875 66.6875 17.875H67.5625C68.0273 17.875 68.4375 17.4922 68.4375 17V13.0625H72.375C72.8398 13.0625 73.25 12.6797 73.25 12.1875V11.3125C73.25 10.8477 72.8398 10.4375 72.375 10.4375Z"
                        fill="white"
                    />
                    <g filter="url(#filter3_d_3223_6742)">
                        <circle cx="18" cy="84" r="15" fill="#3C4048" />
                    </g>
                    <path
                        d="M21 89.3125C21.4688 88.8438 21.125 88.0312 20.4688 88.0312H18.875V84.875H22V86.5C22 87.1562 22.8125 87.5 23.2812 87.0312L25.75 84.5625C26.0625 84.25 26.0625 83.7812 25.75 83.5L23.2812 81C22.8125 80.5312 22 80.875 22 81.5312V83.125H18.8438V80H20.4688C21.125 80 21.4688 79.1875 21 78.7188L18.5 76.25C18.2188 75.9375 17.75 75.9375 17.4375 76.25L14.9688 78.7188C14.5 79.1875 14.8438 80 15.5 80H17.125V83.125H13.9688V81.5312C13.9688 80.875 13.1562 80.5312 12.6875 81L10.2188 83.4688C9.90625 83.7812 9.90625 84.25 10.2188 84.5312L12.6875 87.0312C13.1562 87.5 13.9688 87.1562 13.9688 86.5V84.875H17.125V88.0312H15.5C14.8438 88.0312 14.5 88.8438 14.9688 89.3125L17.4688 91.7812C17.75 92.0938 18.2188 92.0938 18.5312 91.7812L21 89.3125Z"
                        fill="white"
                    />
                    <defs>
                        <filter
                            id="filter0_d_3223_6742"
                            x="460"
                            y="39"
                            width="32"
                            height="32"
                            filterUnits="userSpaceOnUse"
                            color-interpolation-filters="sRGB"
                        >
                            <feFlood
                                flood-opacity="0"
                                result="BackgroundImageFix"
                            />
                            <feColorMatrix
                                in="SourceAlpha"
                                type="matrix"
                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                result="hardAlpha"
                            />
                            <feOffset dy="2" />
                            <feGaussianBlur stdDeviation="1.5" />
                            <feColorMatrix
                                type="matrix"
                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                            />
                            <feBlend
                                mode="normal"
                                in2="BackgroundImageFix"
                                result="effect1_dropShadow_3223_6742"
                            />
                            <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect1_dropShadow_3223_6742"
                                result="shape"
                            />
                        </filter>
                        <filter
                            id="filter1_d_3223_6742"
                            x="460"
                            y="70"
                            width="32"
                            height="32"
                            filterUnits="userSpaceOnUse"
                            color-interpolation-filters="sRGB"
                        >
                            <feFlood
                                flood-opacity="0"
                                result="BackgroundImageFix"
                            />
                            <feColorMatrix
                                in="SourceAlpha"
                                type="matrix"
                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                result="hardAlpha"
                            />
                            <feOffset dy="2" />
                            <feGaussianBlur stdDeviation="1.5" />
                            <feColorMatrix
                                type="matrix"
                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                            />
                            <feBlend
                                mode="normal"
                                in2="BackgroundImageFix"
                                result="effect1_dropShadow_3223_6742"
                            />
                            <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect1_dropShadow_3223_6742"
                                result="shape"
                            />
                        </filter>
                        <filter
                            id="filter2_d_3223_6742"
                            x="460"
                            y="101"
                            width="32"
                            height="32"
                            filterUnits="userSpaceOnUse"
                            color-interpolation-filters="sRGB"
                        >
                            <feFlood
                                flood-opacity="0"
                                result="BackgroundImageFix"
                            />
                            <feColorMatrix
                                in="SourceAlpha"
                                type="matrix"
                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                result="hardAlpha"
                            />
                            <feOffset dy="2" />
                            <feGaussianBlur stdDeviation="1.5" />
                            <feColorMatrix
                                type="matrix"
                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                            />
                            <feBlend
                                mode="normal"
                                in2="BackgroundImageFix"
                                result="effect1_dropShadow_3223_6742"
                            />
                            <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect1_dropShadow_3223_6742"
                                result="shape"
                            />
                        </filter>
                        <filter
                            id="filter3_d_3223_6742"
                            x="0"
                            y="68"
                            width="36"
                            height="36"
                            filterUnits="userSpaceOnUse"
                            color-interpolation-filters="sRGB"
                        >
                            <feFlood
                                flood-opacity="0"
                                result="BackgroundImageFix"
                            />
                            <feColorMatrix
                                in="SourceAlpha"
                                type="matrix"
                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                result="hardAlpha"
                            />
                            <feOffset dy="2" />
                            <feGaussianBlur stdDeviation="1.5" />
                            <feColorMatrix
                                type="matrix"
                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                            />
                            <feBlend
                                mode="normal"
                                in2="BackgroundImageFix"
                                result="effect1_dropShadow_3223_6742"
                            />
                            <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect1_dropShadow_3223_6742"
                                result="shape"
                            />
                        </filter>
                    </defs>
                </svg>
            </div>

            <h2
                class="absolute top-[61px] text-2xl font-medium leading-9 tracking-small text-orange-500"
            >
                {{ title }}
            </h2>
            <h1
                class="absolute top-[100px] text-[124px] font-extrabold leading-tight tracking-[-3px] text-orange-500"
            >
                {{ code }}
            </h1>
        </div>
        <div class="mt-[-6px] flex-col justify-center text-center">
            <div
                class="max-w-sm px-5 text-2xl font-medium leading-9 tracking-small text-gray-600 md:max-w-none md:px-0"
            >
                {{ description }}
            </div>

            <AtomicButton size="md" color="yellow" class="mt-9" @click="goBack">
                <span
                    class="cursor-pointer text-sm font-medium text-gray-600"
                    >{{ $t("vue.go_back") }}</span
                >
            </AtomicButton>
        </div>
    </div>
</template>

<script lang="ts">
import BlankLayout from "../../Layouts/Blank.vue";
import AtomicButton from "@atomic/Buttons/AtomicButton.vue";
import { defineComponent } from "vue";
import Bugsnag from "@bugsnag/js";

export default defineComponent({
    components: {
        AtomicButton,
    },
    layout: BlankLayout,
    props: {
        status: {
            type: Number,
            default: 404,
        },
    },
    computed: {
        code() {
            return {
                503: "503",
                500: "500",
                405: "405",
                404: "404",
                403: "403",
            }[this.status];
        },
        title() {
            return {
                503: this.$t("vue.oops"),
                500: this.$t("vue.oops"),
                405: this.$t("vue.nope"),
                404: this.$t("vue.oops"),
                403: this.$t("vue.you_shall_not_pass"),
            }[this.status];
        },
        description() {
            return {
                503: this.$t("vue.maintenance_message"),
                500: this.$t("vue.server_failed_message"),
                405: this.$t("vue.method_not_allowed"),
                404: this.$t("vue.page_not_found"),
                403: this.$t("vue.access_denied"),
            }[this.status];
        },
    },
    mounted() {
        if ([405, 500, 503].includes(this.status))
            //@ts-ignore
            Bugsnag.notify(this.status);
    },
    methods: {
        goBack() {
            window.history.back();
        },
    },
});
</script>
